import "./lib/core/jquery_bundle_loader";
import "./lib/core/jquery_modal_loader";
import "./lib/core/js_routes_loader";
import "./lib/core/toastr_loader";
import "./common/settings";
import "./common/base";
import "./common/functions/accordionToggle";
import "./common/functions/accordionToggleByDataClass";
import "./common/functions/articlesMenuNavigate";
import "./common/functions/autoCompleteAddress";
import "./common/functions/autoCompleteEmailDomains";
import "./common/functions/cookies";
import "./common/functions/enforceAtLeastOneCheckbox";
import "./common/functions/forms";
import "./common/functions/gtm";
import "./common/functions/gtmEcommerce";
import "./common/functions/guide_contents";
import "./common/functions/initActivoPageViewChart";
import "./common/functions/initializeCarouselForArticlePictures";
import "./common/functions/initializeCleanQuery";
import "./common/functions/initializeDatePicker";
import "./common/functions/initializeEnvBar";
import "./common/functions/initializeFacebookLikeButton";
import "./common/functions/initializeGeneratedArticleSummary";
import "./common/functions/initializeHorizontalScroll";
import "./common/functions/initializeModalForArticlePictures";
import "./common/functions/initializeNumberAnimation";
import "./common/functions/initializeProfileForms";
import "./common/functions/initializeSidebarScrollSpy";
import "./common/functions/initializeStickyBottomOverlay";
import "./common/functions/initializeTwitterFollowButton";
import { lazyLoadAdsense } from "./common/functions/lazyLoadAdsense";
import "./common/functions/lazySizeConfig";
import "./common/functions/others";
import "./common/functions/replies";
import { setReplaceSearchButton } from "./common/functions/searches";
import "./common/functions/setActiveMenuItem";
import setDummyFormValue from "./common/functions/setDummyFormValue";
import "./common/functions/setMediumListSliders";
import "./common/functions/sns";
import "./common/functions/storyShareFeatures";
import "./common/functions/tabNavigation";
import "./common/functions/toggleArticleDetailVisibility";
import "./common/functions/toggleMessageAccordion";
import "./common/functions/triggerEcommerceAddToWishlistEvent";
import "./common/functions/triggerEcommerceEntryEvent";
import "./common/functions/triggerEcommerceTracking";
import "./common/pages/about";
import "./common/pages/after_volunteer_feedbacks";
import "./common/pages/articles";
import "./common/pages/column";
import "./common/pages/contacts";
import "./common/pages/guide_contents";
import "./common/pages/home";
import "./common/pages/people_mypage/application";
import "./common/pages/people_mypage/people";
import "./common/pages/people_mypage/replies";
import "./common/pages/public/replies";
import "./common/pages/reg_users";
import "./common/pages/search";
import "./common/pages/static_pages";
import "./common/pages/stories";
import "./common/pages/tenth_anniversary";
import "./common/pages/users";
import "./async_info/pc_initialize_page";
import "../assets/javascripts/lib/jquery.sticky-kit";
import "../assets/javascripts/lib/js.cookie";
import "../assets/javascripts/lib/lazysizes";
import "../assets/javascripts/lib/ls.unveilhooks";
import "../assets/javascripts/lib/trunk8";
import "../assets/javascripts/lib/chart.min";
import "./pc/articles";
import "./pc/home";
import "./pc/pages/about";
import "./pc/people";
import "./pc/reg_users";
import "./pc/search_for_company";
import "./pc/search";
import "./pc/stories";
import "./common_with_spread/common/pages/article";
import "./common_with_spread/pc/pages/articles";

// ヘッダーでの検索ボタンのリンク化
setReplaceSearchButton();

// 自動広告用にadsenseタグをlazyload
lazyLoadAdsense();

// 会員登録フォームのスパム対策用ダミーフィールド
setDummyFormValue();
